import React from 'react'
import '../../assets/css/detail.css'

const LoaderHOC = (WrappedComponent) => {

    return (props) => (
        <div className="pageWrapper">
            <div className="pageWrapper__container">
                <div className="pageWrapper__container__header">
                    <div className="pageWrapper__container__header__logo">
                        <a href="//vivense.com/">
                            <img src="//cdn.vivense.com/images/header/logo/Vivense-logotype-white-new.svg" alt="Vivense" />
                        </a>
                    </div>
                    <div className="pageWrapper__container__header__text">
                        Sipariş Takip
                    </div>
                </div>
                <div className="pageWrapper__container__content">
                    <WrappedComponent {...props} />
                </div>
            </div>
        </div>
    )

};

export default LoaderHOC;